import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import Chip from 'Chip';

const HotWords = ({ content, onChange }) => {

    const toDetail = (index) => {
        onChange('C', index);
    };

    return (
        <Chip
            key="hotWordsBC"
            id="221445"
            type="static"
            name="hotWordsBC"
            title="热词背景"
            groupName="热词"
        >
        <div className={styles.hotWords} style={{ backgroundImage: `url(${content.hotWordsBC})` }}>
            <img className={styles.title} src={require('../../asset/hotWords.png')} alt="" />
            <Chip
                key="hotWords"
                id="260181"
                type="struct"
                name="hotWords"
                title="热词"
                groupName="热词"
            >
                <div className={styles.btnWp}>
                    {
                        content.hotWords.map((data, index) => {
                            return (
                                <div className={styles.btn} style={{ animationDelay: `${0.05 * index}s` }} key={index} data-index={index} onClick={() => toDetail(index)}>
                                    <a>{data.title}</a>
                                </div>
                            );
                        })
                    }
                </div>
            </Chip>
            <img className={styles.logo} src={require('../../asset/logo.png')} alt="logo" />
        </div>
        </Chip>
    );
};

HotWords.propTypes = {
    content: PropTypes.object,
    onChange: PropTypes.func
};

export default errorBoundary(HotWords);
